import { useState } from "react";


const useShippingState = (customerName) => {
    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [city, setCity] = useState("");
    const [postalCode, setPostalCode] = useState("");

    const shippingDetails = {
        address: {
            line1: addressLine1,
            line2: addressLine2,
            city: city,
            country: "GB",
            postal_code: postalCode
        },
        name: customerName
    };

    return {
        shippingDetails,
        setAddressLine1,
        setAddressLine2,
        setCity,
        setPostalCode,
        shippingName: customerName
    };

};



export default useShippingState;